const { translateName } = require("../../../utils/i18n");
const _ = require("lodash");

const translate = (object, context) => {
    switch (object.joinedEntity) {
        case "FamilyAxis":
        case "SubStoreAxis":
        case "OrganizationAxis":
            return translateName(object.name, _.get(context, "language.id"));
        case "StoreAxis":
            return context.tc && context.tc(object.tKey)
        default:
            return context.tc && context.tc(object.tKey);
    }
};

const joinParams = [
    {
        entityName: "StoreAxis",
        childEntityName: "Store"
    },
    {
        entityName: "FamilyAxis",
        childEntityName: "Family"
    },
    {
        entityName: "OrganizationAxis",
        childEntityName: "Organization"
    },
    {
        entityName: "SubStoreAxis"
    }

];

export const entity = require("./../../utils/entityJoin").joinEntities({
    name: "ThemeAnalyseGroupElement",
    fields: [
        "code",
        "name",
        {
            path: "storeCode",
            f: function() {
                return global.app.S.StoreAxis.objects[0].code;
            }
        },
        {
            path: "childOfAxisEntityName",
            f: function() {
                return joinParams.find(o => o.entityName === this.joinedEntity).childEntityName;
            }
        },
        {
            path: "tName",
            fieldPath: ["name"],
            $f: (object, context, callback) => {
                callback(null, translate(object, context));
            }
        }
    ]
}, joinParams.map(o => o.entityName))
